import React from 'react';
import { Outlet } from 'react-router-dom';
import SideMenu from './SideMenu';
import CopyrightFooter from './CopyrightFooter';

const AppLayout = () => {

  return (
    <>
      <SideMenu />
      <div className="app-layout-content">
        <Outlet />
      </div>
      <div className="app-layout-footer">
        <CopyrightFooter />
      </div>
    </>
  );
};

export default AppLayout;